// Enhanced Google Analytics integration

// Enhanced event tracking
export function trackInteraction(category: string, action: string, label?: string, value?: number) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
      custom_map: {
        dimension1: category,
        dimension2: action
      }
    });
  }
}

// Track enhanced ecommerce events
export function trackPurchase(transactionId: string, value: number, items: any[]) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: 'USD',
      items: items
    });
  }
}

// Track lead generation
export function trackLead(leadType: string, value?: number) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', {
      event_category: 'Lead Generation',
      event_label: leadType,
      value: value
    });
  }
}

// Track video engagement
export function trackVideo(action: string, videoTitle: string, progress?: number) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: 'Video',
      event_label: videoTitle,
      value: progress
    });
  }
}

// Track file downloads
export function trackDownload(fileName: string, fileType: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'file_download', {
      event_category: 'Downloads',
      event_label: fileName,
      file_extension: fileType
    });
  }
}

// Track outbound links
export function trackOutboundLink(url: string, linkText: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'click', {
      event_category: 'Outbound Links',
      event_label: url,
      transport_type: 'beacon'
    });
  }
}

// Track custom dimensions
export function setCustomDimension(index: number, value: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-X5HK4B05HB', {
      [`custom_map.dimension${index}`]: value
    });
  }
}

// Track user timing
export function trackTiming(category: string, variable: string, value: number, label?: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'timing_complete', {
      name: variable,
      value: value,
      event_category: category,
      event_label: label
    });
  }
}

// Track exceptions
export function trackException(description: string, fatal = false) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'exception', {
      description: description,
      fatal: fatal
    });
  }
}